export default class Avatar {
    constructor() {
    }
    getAll() {
        let avatars = [{
            "type": "Avatar",
            "name": "default",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/default-avatar.png",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/default-avatar.png"
        },
        {
            "type": "Avatar",
            "name": "agent",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/agent.png",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/agent.png"
        },
        {
            "type": "Avatar",
            "name": "agent_female",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/agent_female.png",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/agent_female.png"
        },
        {
            "type": "Avatar",
            "name": "person-1",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-1.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-1.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-2",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-2.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-2.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-3",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-3.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-3.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-4",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-4.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-4.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-5",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-5.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-5.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-6",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-6.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-6.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-7",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-7.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-7.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-8",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-8.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-8.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-9",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-9.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-9.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-10",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-10.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-10.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-11",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-11.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-11.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-12",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-12.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-12.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-13",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-13.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-13.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-14",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-14.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-14.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-15",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-15.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-15.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-16",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-16.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-16.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-17",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-17.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-17.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-18",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-18.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-18.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-19",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-19.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-19.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-20",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-20.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-20.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-21",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-21.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-21.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-22",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-22.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-22.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-23",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-23.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-23.jpg"
        },
        {
            "type": "Avatar",
            "name": "person-24",
            "cost": 0,
            "icon":"https://cardsjd.com/cribbage/game/assets/Avatars/person-24.jpg",
            "url":"https://cardsjd.com/cribbage/game/assets/Avatars/person-24.jpg"
        }]
        return avatars;
    }
}